import React from 'react';
import PropTypes from 'prop-types';
import {
  LeftColumnSection,
  LinksColumnSection,
  detailsFooterContentParser
} from '../componentSections/detailsFooterComponents';
import {
  fireDetailsPageComponentFailureFpti,
  parseData
} from '../../../lib/helpers';

const DetailsFooter = ({
  componentContent,
  handleClickFPTI,
  fptiImpression,
  toolName
}) => {
  if (!componentContent) {
    return null;
  }

  const { title, subtitle } = componentContent;

  // temporary, after migration rename linksNew + subtitleLinksNew to links in schema and destructure it in the line above
  let links = componentContent.linksNew || componentContent.links,
    subtitleLink =
      componentContent.subtitleLinkNew || componentContent.subtitleLink;

  let buffSubLinkData = parseData(subtitleLink)[0] || {};

  if (!links || !title) {
    fireDetailsPageComponentFailureFpti({
      data: { links, title },
      componentName: 'DetailsFooter',
      fptiImpression
    });
    return null;
  }

  const linkItemValuesPair = links ? detailsFooterContentParser(links) : [];

  return (
    <div id="details-footer-solution">
      <div className="details-footer-container">
        <LeftColumnSection
          questionsLabel={title}
          helpLabel={subtitle}
          handleClickFPTI={handleClickFPTI}
          subtitleLink={buffSubLinkData}
        />
        {linkItemValuesPair.length > 0 &&
          linkItemValuesPair.map((item, index) => (
            <LinksColumnSection
              key={`details-footer-item${index}`}
              linkItems={item}
              handleClickFPTI={handleClickFPTI}
              toolName={toolName}
            />
          ))}
      </div>
    </div>
  );
};

DetailsFooter.propTypes = {
  componentContent: PropTypes.object,
  handleClickFPTI: PropTypes.func,
  fptiImpression: PropTypes.func.isRequired,
  toolName: PropTypes.string
};

export default DetailsFooter;
